import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SnackBarService } from '@shared/services/snack-bar.service';
import { catchError, EMPTY, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MainDriver } from '../models/main-driver.model';
import { GENERAL_ERROR_MESSAGE } from '@shared/models/messages';

@Injectable()
export class MainDriverApiService {
  readonly http = inject(HttpClient);
  private readonly _messageService = inject(SnackBarService);
  readonly url = `${environment.apiUrl}/main-drivers`;

  getMainDrivers$(): Observable<MainDriver[]> {
    return this.http.get<MainDriver[]>(`${this.url}`).pipe(
      catchError(error => {
        this._messageService.showError(`Failed to retrieve main drivers: ${error.error.message ?? GENERAL_ERROR_MESSAGE}.`);
        return EMPTY;
      })
    );
  }
}
